import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  FormSelect,
  FormTextarea,
  FormCheckbox,
  Button
} from "shards-react";
import { Link } from "react-router-dom";
import TableRow from '../layout/TableRow';
import TableColumnRow from '../layout/TableColumnRow';
import { FcApproval, FcSearch } from "react-icons/fc";
import { FcAcceptDatabase,FcDataConfiguration, FcPlus } from "react-icons/fc";
import ProjectStructureDataService from "../../services/projectStructure.service";
import FunctionDataService from "../../services/function.service";
import supplierService from "../../services/supplier.service";
import projectFileService from "../../services/projectFile.service";
import ProcessFileService from "../../services/processFile.service";
import TempProjectFileDataService from "../../services/tempProjectFile.service";
import Modal from "react-bootstrap/Modal";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TiDeleteOutline } from "react-icons/ti";
import nav_store, {
  types as nav_types,
  actions as nav_actions,
} from "../../_stores/sidenav.store";
import {actions as AppActions} from "../../_stores/app.store";
import Select from 'react-select';

import { validateFileSize } from '../util/validate';

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const INDIA = process.env.REACT_APP_MARKET === "INDIA";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

const joinColumns = [
  {
    label: "Product Code",
    value: "PROD_CODE",
  },
  {
    label: "Product Name",
    value: "PROD_NAME",
  },
  {
    label: "Company Name",
    value: "COMP_NAME",
  },
  {
    label: "UOM",
    value: "UOM",
  }
];

const joinCustomerColumns = [
  {
    label: "Cust Code",
    value: "custcode",
  },
  {
    label: "Cust Name",
    value: "custname",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Street",
    value: "street",
  },
  {
    label: "District",
    value: "district",
  }
];

const joinProductColumns = [
  {
    label: "Product Code",
    value: "prodcode",
  },
  {
    label: "Product Name",
    value: "proddesc",
  },
  {
    label: "Company",
    value: "company",
  }
];

class CreateProjectStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supplierList:"",
      projectStructureList:"",
      projectStructureSelected:"",
      supplierSelected:"",
      showStructureFormFields:false,
      projectFileName:"",
      fileType:"",
      fileFormat:"",
      projectStructureName: "",
      skipRows: "",
      dataHeaderRow: "",
      mergedCell: "",
      validationColumn: "",
      exceptionKeywords: "",
      // exceptionKeywords: "SUTURE, USYNTH",
      sourceTargetColumnMapping: [],
      rows:"",
      columnsRows:"",
      columnsRowsMapping:"",
      headers:"",
      viewTable:false,
      masterTableFields:[],
      rowNoToremove: [],
      
      file: null,
      supplierName: "",
      supplierLocationRow: "",
      reportTypeRow: "",
      supplierNameRow:"",
      reportPeriodRow: "",
      reportPeriodRange: "",
      showSaveBtn:false,
      fileUploaded:false,
      filepath:"",
      transformTextValues: [],
      fileName: "",
      testRunBtn:true,
      enableProjectStructure: true,
      showModalSupplier:false,
      showModalStructure:false,
      selectedProjectSupplierName:"",
      selectedProjectStructureName:"",
      selectedProjectFileName:"",
      selectedSupplierCode:"",
      companyNameInColumns: true,
      companyNameInRows: false,
      companyNameRowsCount: 2,
      companyNameInColumnsIndex: "",
      isStripType: false,
      isCompanyAvailable: true,
      isConcatConversionAndUOM: false,

      separator:"",
      startDate: "",
      endDate: "",
      supplierCode: "",

      startDateData: "",
      endDateData: "",
      supplierCodedata: "",

      showSeparator: false,
      showStartDateIndex: false,
      showEndDateIndex: false,
      showSupplierCodeIndex: false,

      showSupplierName : false,
      showSupplierStatmentPeriodRow: false,
      showSkipRows: false,
      shoDataHeaderRow: false,

      functionsList:[],
      hasHeader: false,
      selectedJoinColumns: null,
      selectedCustomerColumns: null,
      selectedProductColumns: null,
      fileDateFormat: 'DD/MM/YYYY',
      //fileNamingConvention: ''

      allColumnsArray: [],
      selectedAllColumnsArray: [],
      selectedAllColumns: '',
      selectedAllReplaceColumns: ''
    };

    
    this.onChangeSupplierSelected = this.onChangeSupplierSelected.bind(this);
    this.onChangeProjectStructureSelected = this.onChangeProjectStructureSelected.bind(this);
    this.onChangeProjectFileName = this.onChangeProjectFileName.bind(this);
    this.handleTransformTextChange = this.handleTransformTextChange.bind(this);
    this.handleComputedTypeChange = this.handleComputedTypeChange.bind(this);
    this.handleComputedTextChange = this.handleComputedTextChange.bind(this);
    this.colTransformFunctionChange = this.colTransformFunctionChange.bind(this);
    this.transFuncParamValChanged = this.transFuncParamValChanged.bind(this);
    this.onChangeSkipRows = this.onChangeSkipRows.bind(this);
    this.onChangeSupplierNameRow = this.onChangeSupplierNameRow.bind(this);
    this.onChangeSupplierStatmentPeriodRow = this.onChangeSupplierStatmentPeriodRow.bind(this);
    this.onChangeDataHeaderRow = this.onChangeDataHeaderRow.bind(this);
    this.onChangeMergedColumns = this.onChangeMergedColumns.bind(this);
    this.onChangeValidationColumn = this.onChangeValidationColumn.bind(this);
    this.onChangeExceptionKeywords = this.onChangeExceptionKeywords.bind(this);
    this.showTable = this.showTable.bind(this);
    this.clearData = this.clearData.bind(this);
    this.handleAddProjectFileConfigurationForm = this.handleAddProjectFileConfigurationForm.bind(this);
    this.handleUpdateProjectFileForm = this.handleUpdateProjectFileForm.bind(this);
    this.handleCloneProjectFileForm = this.handleCloneProjectFileForm.bind(this);
    this.newProjectFileCongigurationForm = this.newProjectFileCongigurationForm.bind(this);
    this.handleShowModalSupplier = this.handleShowModalSupplier.bind(this);
    this.handleCloseModalSupplier = this.handleCloseModalSupplier.bind(this);
    this.selectSupplier = this.selectSupplier.bind(this);
    this.onChangeSupplierNameTxt = this.onChangeSupplierNameTxt.bind(this);
    this.onChangeSupplierCodeTxt = this.onChangeSupplierCodeTxt.bind(this);
    this.onChangeSupplierAddressTxt = this.onChangeSupplierAddressTxt.bind(this);
    this.onChangeCompanyNameInColumns = this.onChangeCompanyNameInColumns.bind(this);
    this.onChangeCompanyNameInRows = this.onChangeCompanyNameInRows.bind(this);
    this.onChangeCompanyNameRowsCount = this.onChangeCompanyNameRowsCount.bind(this);
    this.onChangeCompanyNameInColumnsIndex = this.onChangeCompanyNameInColumnsIndex.bind(this);
    this.onChangeIsStripType = this.onChangeIsStripType.bind(this);
    this.onChangeIsCompanyAvailable = this.onChangeIsCompanyAvailable.bind(this);
    this.onChangeIsConcatConversionAndUOM = this.onChangeIsConcatConversionAndUOM.bind(this);
    

    this.onChangeSeparator = this.onChangeSeparator.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeSupplierCode = this.onChangeSupplierCode.bind(this);
    this.viewOriginalFile = this.viewOriginalFile.bind(this);
    this.onChangeHasHeader = this.onChangeHasHeader.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);
    
    this.onChangeStartIndex = this.onChangeStartIndex.bind(this);
    this.onChangeTotalIndex = this.onChangeTotalIndex.bind(this);
    this.onChangeFileDateFormat = this.onChangeFileDateFormat.bind(this);
    // this.onChangeFileNamingConvention = this.onChangeFileNamingConvention.bind(this);
    // this.onBlurFileNamingConvention = this.onBlurFileNamingConvention.bind(this);

    this.onChangeSelectedAllColumns = this.onChangeSelectedAllColumns.bind(this);
    this.handleSelectedAllColumnsArrayChange = this.handleSelectedAllColumnsArrayChange.bind(this);
    this.onChangeSelectedAllReplaceColumns = this.onChangeSelectedAllReplaceColumns.bind(this);

    this.addAdditionalField = this.addAdditionalField.bind(this);
    
  }

  componentDidMount() {
    AppActions.setLoading(true);
    this.retrieveFunctionDetails();
    this.retrieveSupplierList();
    this.retrieveProjectStructureList();

    if(this.props.projectFileId){
      this.retrieveProjectFileDetails();
      this.setState({
          testRunBtn: true,
      });
    } else {
      this.setState({
        selectedJoinColumns: joinColumns,
      });
      this.setState({
        selectedCustomerColumns: joinCustomerColumns,
      });
      this.setState({
        selectedProductColumns: joinProductColumns,
      });
    }
    AppActions.setLoading(false);

    // this.setState({ selectedJoinColumns: [...joinColumns] }, () =>
    //   console.log(`Option selected:`, this.state.selectedJoinColumns)
    // );
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectId != prevProps.projectId)
      this.retrieveProjectStructureList();
  }

  retrieveFunctionDetails(){
    FunctionDataService.getAll().then((response) => {
      var fnDtls = response.data.data;
      this.setState({
        functionsList:fnDtls
      });
    });
  }

  retrieveSupplierList(){
    AppActions.setLoading(true);
    supplierService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      this.setState({
        supplierList:response.data.data,
        supplierFilteredList:response.data.data
      })
    });
  }
  
  retrieveProjectStructureList(){
    AppActions.setLoading(true);
		ProjectStructureDataService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      this.setState({
				projectStructureList:response.data.data,
			})
  	});
	}

  addAdditionalItem() {
    console.log('addAdditionalItem.clicked');
    const { masterTableFields, masterTableFieldInitial, masterTableFieldMissingInitial } = this.state;
    if(masterTableFieldMissingInitial.length > 0){
      const newAddItem = masterTableFieldMissingInitial[0];
      this.setState({
        masterTableFieldInitial: [...masterTableFieldInitial, newAddItem],
        masterTableFieldMissingInitial: masterTableFieldMissingInitial.slice(1)
      }, () => {
        // console.log('masterTableFields.masterTableFieldInitial.after', this.state.masterTableFieldInitial);
        // console.log('masterTableFields.masterTableFieldMissingInitial.after', this.state.masterTableFieldMissingInitial);
      });
    }
  }

  addAdditionalField(e, field_name) {
    const { masterTableFields } = this.state;
    
    const newField = {
      //_id: Date.now().toString(),
      parameterName: "ColumnList",
      source: "FieldName",
      dataType: "String",
      sourceField: "", // Example value
    };
    
    const fieldColArr = masterTableFields.map((stc) => {
      if (stc.fieldName === field_name) {
        if (stc.transformFunction) {
          if (
            stc.transformFunction.parameters &&
            stc.transformFunction.parameters.length
          ) {
            
            // Separate "source: CustomValue" parameter and other parameters
            const otherParameters = stc.transformFunction.parameters.filter(param => param.source !== "CustomValue");
            const customValueParameter = stc.transformFunction.parameters.find(param => param.source === "CustomValue");
            
            const updatedParameters = [...otherParameters];
            updatedParameters.push(newField);

            // Add "source: CustomValue" parameter at the end
            if (customValueParameter) {
                updatedParameters.push(customValueParameter);
            }

            // Update the parameters array
            stc.transformFunction.parameters = updatedParameters;

            //stc.transformFunction.parameters = [...stc.transformFunction.parameters, newField];
            return stc;
          }
          return stc;
        }
        return stc;
      }
      return stc;
    });

    
    this.setState({
      masterTableFields: fieldColArr,
    }, () => {
      // console.log('masterTableFields.masterTableFields.after', this.state.masterTableFields);
      // console.log('masterTableFields.masterTableFieldMissingInitial.after', this.state.masterTableFieldMissingInitial);
    });
  }

  viewOriginalFile(file, runtype) {

    console.log('viewOriginalFile.selectedJoinColumns', this.state.selectedJoinColumns);
    const { fileName } = this.state;
    let finalFileName = fileName;
    if(file){
      finalFileName = file.name;
    }
    if(finalFileName){

      AppActions.setLoading(true);
      //const filePath = `/Users/murugesh.nadar/Documents/work/IMS/iqvia-unstructureddata/server/tempuploads/${fileName.name}`;
      const { sourceTargetColumnMapping } = this.state;
      
      let state = { fileName: fileName, ...this.state };
      delete state.masterTableFields;
      delete state.projectStructureList;
      delete state.supplierFilteredList;
      delete state.supplierList;
      delete state.rows;

      state.runtype = runtype;
      state.selectedJoinColumns = this.state.selectedJoinColumns;
      state.selectedCustomerColumns = this.state.selectedCustomerColumns;
      state.selectedProductColumns = this.state.selectedProductColumns;

      ProcessFileService.viewOriginalFile({state: state, fileName: finalFileName, projectId: this.props.projectId  }).then((response) => {
        AppActions.setLoading(false);
        console.log('response.data.output.', response.data.output);
        if(response.data.output && response.data.output){
          if(sourceTargetColumnMapping.length > 0){
            this.setState({ rows: response.data.output, 
              headers: response.data.output.headerData, 
              fileUploaded: true,
              supplierName: response.data.output.supplierName,
              reportPeriodRange: response.data.output.dateRange,
            });
          } else {
            this.setState({ 
              headers: response.data.output.headerData, 
              fileUploaded: true,
              supplierName: response.data.output.supplierName,
              reportPeriodRange: response.data.output.dateRange,
            });
          }
          if(response.data.output.message){
            const notify_message =({
              type:"error",
              message: response.data.output.message
            });
            this.notify(notify_message.type,notify_message.message);
            AppActions.setLoading(false);
            return;
          }
        }
        this.setState({ testRunBtn: true});
        this.showTable();
      });

    } else {
      console.error('No File Name Provided');
    }

    
  }

  
  retrieveProjectStructureDetails(projectStructureId){
    //alert();
    AppActions.setLoading(true);
		ProjectStructureDataService.get(projectStructureId).then((response) => {
			AppActions.setLoading(false);
      var projectStructureDetails = response.data.data;
      const masterTableFields = projectStructureDetails.sourceTargetColumnMapping;

      console.log('projectStructureDetails', projectStructureDetails);
      let masterTableFieldInitial = [];
      let masterTableFieldMissingInitial = [];
      masterTableFields && masterTableFields.map((mitem,mindex) => {
        if(mitem.apiKey && mitem.apiKey.replace('Additional_Column_', '') > 3 && !mitem.target) {
          masterTableFieldMissingInitial.push(mitem);
          return;
        } else {
          masterTableFieldInitial.push(mitem);
        };
      });
      
      this.setState({
        projectStructureName: projectStructureDetails.projectStructureName,
        fileType: projectStructureDetails.fileType,
        fileFormat: projectStructureDetails.fileFormat,
        skipRows: projectStructureDetails.skipRows,
        dataHeaderRow: projectStructureDetails.dataHeaderRow,
        mergedCell: projectStructureDetails.mergedCell,
        validationColumn: projectStructureDetails.validationColumn,
        exceptionKeywords: projectStructureDetails.exceptionKeywords,
        supplierNameRow: projectStructureDetails.supplierNameRow,
        supplierStatmentPeriodRow: projectStructureDetails.supplierStatmentPeriodRow,
        separator :projectStructureDetails.separator,
        startDate: projectStructureDetails.startDate,
        endDate: projectStructureDetails.endDate,
        supplierCode: projectStructureDetails.supplierCode,
        masterTableFields:projectStructureDetails.sourceTargetColumnMapping,
        masterTableFieldInitial: masterTableFieldInitial,
        masterTableFieldMissingInitial: masterTableFieldMissingInitial,
        sourceTargetColumnMapping: projectStructureDetails.sourceTargetColumnMapping,
        companyNameInColumns: projectStructureDetails.companyNameInColumns,
        companyNameInRows: projectStructureDetails.companyNameInRows || false,
        isStripType: projectStructureDetails.isStripType || false,
        isCompanyAvailable: projectStructureDetails.isCompanyAvailable,
        isConcatConversionAndUOM: projectStructureDetails.isConcatConversionAndUOM || false,
        companyNameRowsCount: projectStructureDetails.companyNameRowsCount || 2,
        companyNameInColumnsIndex: projectStructureDetails.companyNameInColumnsIndex || 'C',
        hasHeader: projectStructureDetails.hasHeader,
        fileDateFormat: projectStructureDetails.fileDateFormat,

        allColumnsArray: this.transformFields(projectStructureDetails.sourceTargetColumnMapping),
        selectedAllColumnsArray: projectStructureDetails.selectedAllColumnsArray,
        selectedAllColumns: projectStructureDetails.selectedAllColumns,
        selectedAllReplaceColumns: projectStructureDetails.selectedAllReplaceColumns,
			});

      if(projectStructureDetails.fileType === "textFile")
      {
        if(projectStructureDetails.hasHeader){
          this.setState({
            // supplierName : "",
            // supplierStatmentPeriodRow: "",
            // skipRows: "",
            // dataHeaderRow: "",
    
            showSupplierName : true,
            showSupplierStatmentPeriodRow: true,
            showSkipRows: true,
            shoDataHeaderRow: true,
            
            showseparator: false,
            showStartDateIndex: false,
            showEndDateIndex: false,
            showSupplierCodeIndex: false
          });
        } else {
          this.setState({
    
            supplierName : "",
            supplierStatmentPeriodRow: "",
            skipRows: "",
            dataHeaderRow: "",
    
            showSupplierName : false,
            showSupplierStatmentPeriodRow: false,
            showSkipRows: false,
            shoDataHeaderRow: false,
    
            showSeparator: true,
            showStartDateIndex: true,
            showEndDateIndex: true,
            showSupplierCodeIndex: true,
    
          });
        }
      }else if(projectStructureDetails.fileType === "excelFile" || projectStructureDetails.fileType === "csvFile" || projectStructureDetails.fileType === "fixedLength"){
        this.setState({
         
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
  
          showSupplierName : true,
          showSupplierStatmentPeriodRow: true,
          showSkipRows: true,
          shoDataHeaderRow: true,
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
        });
      }else{
        this.setState({
         
          supplierName : "",
          supplierStatmentPeriodRow: "",
          skipRows: "",
          dataHeaderRow: "",
  
          showSupplierName : false,
          showSupplierStatmentPeriodRow: false,
          showSkipRows: false,
          shoDataHeaderRow: false,
  
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
  
  
        });
      }

  	});
	}

   retrieveProjectFileDetails(){
    //alert();
    AppActions.setLoading(true);
		projectFileService.get(this.props.projectFileId).then((response) => {
			AppActions.setLoading(false);
      var projectFileService = response.data.data[0];

      console.log('projectFileService', projectFileService);
      console.log('projectFileService.structureSupplierMapping.isCompanyAvailable', projectFileService.structureSupplierMapping.isCompanyAvailable);

      let masterTableFields = projectFileService.structureSupplierMapping.sourceTargetColumnMapping;
      let masterTableFieldInitial = [];
      let masterTableFieldMissingInitial = [];
      masterTableFields && masterTableFields.map((mitem,mindex) => {
        if(mitem.apiKey && mitem.apiKey.replace('Additional_Column_', '') > 3 && !mitem.target) {
          masterTableFieldMissingInitial.push(mitem);
          return;
        } else {
          masterTableFieldInitial.push(mitem);
        };
      });
      console.log('masterTableFields.masterTableFieldInitial', masterTableFieldInitial);
      
      this.setState({
        id: projectFileService.id,
        selectedProjectSupplierName : projectFileService.projectSupplierId.supplierName,
        selectedProjectStructureName : projectFileService.projectStructureId.projectStructureName,
        selectedProjectFileName: projectFileService.projectFileName, 
        projectFileName: projectFileService.projectFileName,
        showStructureFormFields:true,
        projectStructureSelected:projectFileService.projectStructureId._id,
        supplierSelected:projectFileService.projectSupplierId._id,
      //    projectStructureId: projectFileService.projectStructureId,
      //    projectSupplierId: projectFileService.projectSupplierId,
        projectStructureName: projectFileService.projectStructureId.projectStructureName,
        fileType: projectFileService.structureSupplierMapping.fileType,
        fileFormat: projectFileService.structureSupplierMapping.fileFormat,
        skipRows: projectFileService.structureSupplierMapping.skipRows,
        dataHeaderRow: projectFileService.structureSupplierMapping.dataHeaderRow,
        mergedCell: projectFileService.structureSupplierMapping.mergedCell,
        validationColumn: projectFileService.structureSupplierMapping.validationColumn,
        exceptionKeywords: projectFileService.structureSupplierMapping.exceptionKeywords,
        
        separator :projectFileService.structureSupplierMapping.separator,
        startDate: projectFileService.structureSupplierMapping.startDate,
        endDate: projectFileService.structureSupplierMapping.endDate,
        supplierCode: projectFileService.structureSupplierMapping.supplierCode,

        supplierNameRow: projectFileService.structureSupplierMapping.supplierNameRow,
        fileName:projectFileService.structureSupplierMapping.file,
        supplierStatmentPeriodRow: projectFileService.structureSupplierMapping.supplierStatmentPeriodRow,
        supplierName: "",
        reportPeriodRange: "",
        masterTableFields:projectFileService.structureSupplierMapping.sourceTargetColumnMapping,
        masterTableFieldInitial: masterTableFieldInitial,
        masterTableFieldMissingInitial: masterTableFieldMissingInitial,
        sourceTargetColumnMapping: projectFileService.structureSupplierMapping.sourceTargetColumnMapping,
        companyNameInColumns: projectFileService.structureSupplierMapping.companyNameInColumns,
        companyNameInRows: projectFileService.structureSupplierMapping.companyNameInRows,
        isStripType: projectFileService.structureSupplierMapping.isStripType,
        isCompanyAvailable: projectFileService.structureSupplierMapping.isCompanyAvailable,
        isConcatConversionAndUOM: projectFileService.structureSupplierMapping.isConcatConversionAndUOM,
        companyNameRowsCount: projectFileService.structureSupplierMapping.companyNameRowsCount,
        companyNameInColumnsIndex: projectFileService.structureSupplierMapping.companyNameInColumnsIndex,
        hasHeader: projectFileService.structureSupplierMapping.hasHeader,
        fileDateFormat: projectFileService.structureSupplierMapping.fileDateFormat,
        selectedJoinColumns: (projectFileService.structureSupplierMapping.selectedJoinColumns || []).length === 0 ? joinColumns : projectFileService.structureSupplierMapping.selectedJoinColumns,
        selectedCustomerColumns: (projectFileService.structureSupplierMapping.selectedCustomerColumns || []).length === 0 ? joinCustomerColumns : projectFileService.structureSupplierMapping.selectedCustomerColumns,
        selectedProductColumns: (projectFileService.structureSupplierMapping.selectedProductColumns || []).length === 0 ? joinProductColumns : projectFileService.structureSupplierMapping.selectedProductColumns,
        allColumnsArray: this.transformFields(projectFileService.structureSupplierMapping.sourceTargetColumnMapping),
        selectedAllColumnsArray:  projectFileService.structureSupplierMapping.selectedAllColumnsArray,
        selectedAllColumns:  projectFileService.structureSupplierMapping.selectedAllColumns,
        selectedAllReplaceColumns: projectFileService.structureSupplierMapping.selectedAllReplaceColumns,
			});

      if(this.props.cloneText){
        this.setState({
          projectFileName: "",
        })
      }


      if(projectFileService.structureSupplierMapping.fileType === "textFile")
      {
        if(projectFileService.structureSupplierMapping.hasHeader){
          this.setState({
            // supplierName : "",
            // supplierStatmentPeriodRow: "",
            // skipRows: "",
            // dataHeaderRow: "",
    
            showSupplierName : true,
            showSupplierStatmentPeriodRow: true,
            showSkipRows: true,
            shoDataHeaderRow: true,
            
            showseparator: false,
            showStartDateIndex: false,
            showEndDateIndex: false,
            showSupplierCodeIndex: false
          });
        } else {
          this.setState({
    
            supplierName : "",
            supplierStatmentPeriodRow: "",
            skipRows: "",
            dataHeaderRow: "",
    
            showSupplierName : false,
            showSupplierStatmentPeriodRow: false,
            showSkipRows: false,
            shoDataHeaderRow: false,
    
            showSeparator: true,
            showStartDateIndex: true,
            showEndDateIndex: true,
            showSupplierCodeIndex: true,
    
          });
        }
      }else if(projectFileService.structureSupplierMapping.fileType === "excelFile" || projectFileService.structureSupplierMapping.fileType === "csvFile" || projectFileService.structureSupplierMapping.fileType === "fixedLength"){
        this.setState({
         
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
  
          showSupplierName : true,
          showSupplierStatmentPeriodRow: true,
          showSkipRows: true,
          shoDataHeaderRow: true,
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
        });
      }else{
        this.setState({
         
          supplierName : "",
          supplierStatmentPeriodRow: "",
          skipRows: "",
          dataHeaderRow: "",
  
          showSupplierName : false,
          showSupplierStatmentPeriodRow: false,
          showSkipRows: false,
          shoDataHeaderRow: false,
  
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
          
          showSeparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
  
  
        });
      }
  	});
	 }


  // JavaScript function to transform the array
  transformFields(fields) {
    return fields
        .filter(field => field.apiKey)  // Filter out fields where apiKey is empty
        .map(field => ({
            label: field.fieldName.replace(/_/g, ' ').toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase()), // Title case label
            value: field.apiKey
        }));
  };

  onChangeSupplierSelected(id){

    var selectedSupplier = this.state.supplierList.filter(item => item.id === id)
    var supplierCode = selectedSupplier[0].supplierCode;
    this.setState({
         ...this.state,
         supplierSelected : id, 
         supplierSelectedName: selectedSupplier[0].supplierName,
         projectFileName : supplierCode,
         selectedSupplierCode : supplierCode
    });
    
    if(this.props.cloneText){
      var selectedProjectStructureName = this.state.selectedProjectStructureName
      this.setState({
        projectFileName: supplierCode + " - " + selectedProjectStructureName
      })
    }

  }

  onChangeProjectStructureSelected(e) {

 		var projectStructureSelected = e.target.value;
    var newProjectFileName ="";
    var selectedProjectStructure = this.state.projectStructureList.filter(item => item.id === e.target.value)
    var projectStructureName = selectedProjectStructure[0].projectStructureName;
    var sourceTargetColumnMapping = selectedProjectStructure[0].sourceTargetColumnMapping;
    var supplierCode = this.state.selectedSupplierCode;
    newProjectFileName = supplierCode + " - " + projectStructureName;
   // alert(projectFileName);
    this.setState({
      ...this.state,
     // masterTableFields: masterTableFields,
      showStructureFormFields:true,
      projectStructureSelected:projectStructureSelected,
      projectFileName : newProjectFileName,
      sourceTargetColumnMapping:sourceTargetColumnMapping
    });
    this.retrieveProjectStructureDetails(projectStructureSelected);
	}

  onChangeProjectFileName(e) {
		this.setState({
			projectFileName: e.target.value,
		});
	}

  onChangeSkipRows(e) {
		this.setState({
			skipRows: e.target.value,
		});
	}

  onChangeSeparator(e){
    this.setState({
      separator: e.target.value,
    });
  }

  onChangeStartDate(e){
    this.setState({
      startDate: e.target.value,
    });
  }

  onChangeEndDate(e){
    this.setState({
      endDate: e.target.value,
    });
  }

  onChangeSupplierCode(e) {
    this.setState({
      supplierCode: e.target.value,
    });
  }

  onChangeSupplierNameRow(e) {
		this.setState({
			supplierNameRow: e.target.value,
		});
	}

  onChangeSupplierStatmentPeriodRow(e) {
		this.setState({
			supplierStatmentPeriodRow: e.target.value,
		});
	}

  onChangeHasHeader(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			hasHeader: isTrueSet,
		});

    if(isTrueSet){
      this.setState({
        separator :"",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName : true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,
        
        showseparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false
      });
    } else {
      this.setState({

        supplierName : "",
        supplierStatmentPeriodRow: "",
        skipRows: "",
        dataHeaderRow: "",

        showSupplierName : false,
        showSupplierStatmentPeriodRow: false,
        showSkipRows: false,
        shoDataHeaderRow: false,

        showseparator: true,
        showStartDateIndex: true,
        showEndDateIndex: true,
        showSupplierCodeIndex: true,

      });
    }
	}

  onChangeCompanyNameInColumns(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			companyNameInColumns: isTrueSet,
		});
	}

  onChangeCompanyNameInRows(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			companyNameInRows: isTrueSet,
		});
	}

  onChangeIsStripType(e) {
    var isTrueSet = (e.target.value === 'true');
		this.setState({
			isStripType: isTrueSet,
		});
	}

  onChangeFileDateFormat(e) {
    this.setState({
			fileDateFormat: e.target.value,
		});
	}

  onChangeIsCompanyAvailable(e) {
    var isTrueSet = (e.target.value === 'true');
    this.setState({
			isCompanyAvailable: isTrueSet,
		});
	}

  onChangeIsConcatConversionAndUOM(e) {
    var isTrueSet = (e.target.value === 'true');
    this.setState({
			isConcatConversionAndUOM: isTrueSet,
		});
	}

  onChangeCompanyNameRowsCount(e) {
    this.setState({
			companyNameRowsCount: e.target.value,
		});
	}

  onChangeCompanyNameInColumnsIndex(e) {
    this.setState({
			companyNameInColumnsIndex: e.target.value,
		});
	}

  onChangeDataHeaderRow(e) {
		this.setState({
			dataHeaderRow: e.target.value,
		});
	}

  onChangeMergedColumns(e) {
		this.setState({
			mergedCell: e.target.value,
		});
	}

  onChangeValidationColumn(e) {
		this.setState({
			validationColumn: e.target.value,
		});
	}

  onChangeSelectedAllColumns(e) {
    this.setState({
			selectedAllColumns: e.target.value,
		});
  }

  onChangeExceptionKeywords(e) {
		this.setState({
			exceptionKeywords: e.target.value,
		});
	}

  handleShowModalSupplier() {
    this.setState({
      showModalSupplier: true,
    });
  }

  handleCloseModalSupplier() {
    this.setState({
      showModalSupplier: false,
    });
  }

  selectSupplier(id){
    this.onChangeSupplierSelected(id)
    this.setState({
      showModalSupplier: false,
      enableProjectStructure:false
    });
  }

  onChangeStartIndex(e, field_name){
    const { target: { value, name } } = e;

    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray = sourceTargetColumnMapping.length > 0 ? [...sourceTargetColumnMapping] : [...masterTableFields];

    sourceTargetColumnMappingArray.map(item => {
      if(item.fieldName === name) {
        item.source = name;
        //item.target = value === "Select Target Field" ? '' : value;
        item.startIndex = value;
      }
    });

    this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });

  }

  onChangeTotalIndex(e, field_name){
    const { target: { value, name } } = e;

    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray = sourceTargetColumnMapping.length > 0 ? [...sourceTargetColumnMapping] : [...masterTableFields];

    sourceTargetColumnMappingArray.map(item => {
      if(item.fieldName === name) {
        item.source = name;
        //item.target = value === "Select Target Field" ? '' : value;
        item.totalIndex = value;
      }
    });

    this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
  }

  onChangeSupplierNameTxt(e){
    var str= e.target.value.toLowerCase();
    var supplier = this.state.supplierList.filter(function(data) {
      if(data.supplierName.toString().toLowerCase().includes(str)){
        return true
      }
    });
    
    this.setState({
      supplierFilteredList: supplier,
    //  supplierCodeTxt:"",
    //  supplierAddressTxt:"",
    });
  }
  onChangeSupplierCodeTxt(e){

    var str= e.target.value.toLowerCase();
    var supplier = this.state.supplierList.filter(function(data) {
      if(data.supplierCode.toString().toLowerCase().includes(str)){
        return true
      }
    });
    
    this.setState({
      supplierFilteredList: supplier,
   //   supplierNameTxt:"",
   //   supplierAddressTxt:"",
    });
  }
  onChangeSupplierAddressTxt(e){
    var str= e.target.value.toLowerCase();
    var supplier = this.state.supplierList.filter(function(data) {
      if(data.supplierAddress.toString().toLowerCase().includes(str)){
        return true
      }
    });
    
    this.setState({
      supplierFilteredList: supplier,
  //    supplierNameTxt:"",
  //    supplierCodeTxt:"",
    });
  }

  getFileExtension(name) {
    const parts = name.split('.');

    if (parts.length > 0) {
        return parts.pop();
    }

    return false;
  }

  isValidExtension(name) {
    let extension = this.getFileExtension(name);
    extension = extension && extension.toLowerCase() || '';
    const {fileType} = this.state;
    let result = false;
    if(fileType === "textFile" || fileType === "TEXT File") {
      result = extension === 'txt';
    } else if(fileType === "excelFile" || fileType === "EXCEL File") {
      result = (extension === 'xls' || extension === 'xlsx');
    } else if(fileType === "csvFile") {
      result = extension === 'csv';
    } else if(fileType === "fixedLength") {
      result = (extension === 'xls' || extension === 'xlsx' || extension === 'txt' || extension === 'csv');
    }
    return result;
}

validateFileAttached(file) {
  let supplierNo = ( (file.name.startsWith('SAS')) || file.name.startsWith('sas')) ? 
                      file.name.slice(3, 9) : 
                      (file.name.startsWith('P') || file.name.startsWith('p')) ? 
                      file.name.slice(1, 7) : '';

    let projectFileName = this.state.projectFileName;
    if(!projectFileName.includes(supplierNo)){
      const notify_message =({
        type:"error",
        message:"Incorrect Supplier Attached"
      });
      this.notify(notify_message.type,notify_message.message);
      AppActions.setLoading(true);
      return;
    }

    let fileType = this.state.fileType;
    let fileExtention = this.getFileExtension(file.name);
    fileExtention = fileExtention && fileExtention.toLowerCase() || '';
    if(fileType === "excelFile" || fileType === "EXCEL File") {
      if(fileExtention !== 'xls' && fileExtention !== 'xlsx'){
        const notify_message =({
          type:"error",
          message: `File type selected is Excel File but attached is an ${fileExtention[fileExtention.length - 1]}`
        });
        this.notify(notify_message.type,notify_message.message);
        AppActions.setLoading(true);
        return;
      }
    } else if(fileType === "csvFile") {
      if(fileExtention !== 'csv'){
        const notify_message =({
          type:"error",
          message: `File type selected is CSV File but attached is an ${fileExtention[fileExtention.length - 1]}`
        });
        this.notify(notify_message.type,notify_message.message);
        return;
      }
    } else if(fileType === "textFile" || fileType === "TEXT File") {
      if(fileExtention !== 'txt'){
        const notify_message =({
          type:"error",
          message: `File type selected is Text File but attached is an ${fileExtention[fileExtention.length - 1]}`
        });
        this.notify(notify_message.type,notify_message.message);
        AppActions.setLoading(true);
        return;
      }
    }

    let fileFormat = this.state.fileFormat;
    console.log('fileFormat', fileFormat);
    if(fileFormat === "Product Master" || fileFormat === "P FILE"){
      console.log('file.name', file.name);
      // if(!(file.name.startsWith('P') || file.name.startsWith('p'))){
      //   const notify_message =({
      //     type:"error",
      //     message: `File Format is selected is Product Master but attached is different format`
      //   });
      //   this.notify(notify_message.type,notify_message.message);
      // AppActions.setLoading(true);
      //   return;
      // }
    } else {
      // if(!(file.name.startsWith('SAS') || file.name.startsWith('sas'))){
      //   const notify_message =({
      //     type:"error",
      //     message:`File Format is selected is Product Master but attached is different format`
      //   });
      //   this.notify(notify_message.type,notify_message.message);
      // AppActions.setLoading(true);
      //   return;
      // }
  }
}

  handleChange(selectedOption) {

    console.log(`handleChange Option selected:`, selectedOption);


    this.setState({ selectedJoinColumns: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedJoinColumns)
    );
  };

  handleCustomerChange(selectedOption) {
    console.log(`handleChange Option selected:`, selectedOption);
    this.setState({ selectedCustomerColumns: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedCustomerColumns)
    );
  };

  handleProductChange(selectedOption) {
    console.log(`handleChange Option selected:`, selectedOption);
    this.setState({ selectedProductColumns: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedProductColumns)
    );
  };

  handleSelectedAllColumnsArrayChange(selectedOption) {

    console.log(`handleSelectedAllColumnsArrayChange Option selected:`, selectedOption);


    this.setState({ selectedAllColumnsArray: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedAllColumnsArray)
    );
  };

  onChangeSelectedAllReplaceColumns(e) {
    this.setState({
			selectedAllReplaceColumns: e.target.value,
		});
  }

  

  readFile(e) {
      const { target } = e;
      let file = null;

      if (target.files && target.files.length > 0) {
          file = target.files[0];

          const isValid = validateFileSize(file);
          if (!isValid) return;

          this.validateFileAttached(file);

          if (!this.isValidExtension(file.name)) {
            const notify_message =({
              type:"error",
              message:"File Extension Incorrect"
            });
            this.notify(notify_message.type,notify_message.message);
            return;
        }
      }
      
      var data = {
          projectId:this.props.projectId,
          projectStructureName: this.state.projectStructureName,
          fileType:this.state.fileType,
          file: file,
      }
       AppActions.setLoading(true);
       TempProjectFileDataService.create(data)
       .then((response) => {
         AppActions.setLoading(false);
         if(response.data.success){ // check for success
           var notify_message =({
             type:"success",
             message:"Project Structure has been created successfully."
           });
           this.viewOriginalFile(file);
         }else{
           if(response.data.err.message){ // fields error
             var notify_message =({
               type:"error",
               message:response.data.err.message
             });
           }
           else{ // mongo error
             var notify_message =({ 
               type:"error",
               message:"Duplicate Project Structure Name "
             });
           }
           this.notify(notify_message.type,notify_message.message);
         }
         
       });
     
     this.setState({ file : file });
      
  }

  clearData(){
    localStorage.clear();
    this.setState({
      rows: ""
		});
  }

  showTable(){
    //alert();
    this.setState({
      viewTable: true,
      showSaveBtn: true,
		});
  }

  newProjectFileCongigurationForm(){

    this.setState({ 
      projectStructureName:"",
      fileType:"",
      fileFormat:"",
      skipRows:"",
      supplierName: "",
      reportPeriodRange: "",
      dataHeaderRow:"",
      validationColumn:"",
      exceptionKeywords:"",
      separator :"",
      startDate: "",
      endDate: "",
      supplierCode: "",
      sourceTargetColumnMapping:""
     });
  }

  handleAddProjectFileConfigurationForm() {

    const sourceTargetColumnMapping = this.deleteUnselectedColumns();

    var data = {
        projectId:this.props.projectId,
        projectStructureId:this.state.projectStructureSelected,
        projectSupplierId: this.state.supplierSelected,
        projectFileName: this.state.projectFileName,
        file: this.state.file,
        structureSupplierMapping: {
          fileType:this.state.fileType,
          fileFormat: this.state.fileFormat,
          supplierNameRow : this.state.supplierNameRow,
          supplierStatmentPeriodRow : this.state.supplierStatmentPeriodRow,
          skipRows: this.state.skipRows,
          dataHeaderRow: this.state.dataHeaderRow,
          mergedCell: this.state.mergedCell,
          validationColumn: this.state.validationColumn,
          exceptionKeywords: this.state.exceptionKeywords,
          
          separator :this.state.separator,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          supplierCode: this.state.supplierCode,

       //   file: this.state.file,
          supplierName: this.state.supplierName,
          reportPeriodRange: this.state.reportPeriodRange,
          sourceTargetColumnMapping:sourceTargetColumnMapping,
          companyNameInColumns: this.state.companyNameInColumns,
          companyNameInRows: this.state.companyNameInRows,
          isStripType: this.state.isStripType,
          isCompanyAvailable: this.state.isCompanyAvailable || true,
          isConcatConversionAndUOM: this.state.isConcatConversionAndUOM,
          companyNameRowsCount: this.state.companyNameRowsCount,
          companyNameInColumnsIndex: this.state.companyNameInColumnsIndex,
          selectedJoinColumns: this.state.selectedJoinColumns,
          hasHeader: this.state.hasHeader,
          companyNameRowsCount: this.state.companyNameRowsCount,
          companyNameInColumnsIndex: this.state.companyNameInColumnsIndex,
          selectedJoinColumns: this.state.selectedJoinColumns,
          fileDateFormat: this.state.fileDateFormat,
          selectedAllColumnsArray: this.state.selectedAllColumnsArray,
          selectedAllColumns: this.state.selectedAllColumns,
          selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
          selectedCustomerColumns: this.state.selectedCustomerColumns,
          selectedProductColumns: this.state.selectedProductColumns
        }
    }
    AppActions.setLoading(true);
		projectFileService.create(data)
     .then((response) => {
        AppActions.setLoading(false);
        if(response.data.success){ // check for success
          this.newProjectFileCongigurationForm();
          var notify_message =({
            type:"success",
            message:"Project File Configuration has been created successfully."
          });
          nav_actions.setSideNav(nav_store.dispatch, {});
          this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:response.data.err.name + " - May be duplicate Records"
            });
          }
          this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }
        
      });
	}

  async handleUpdateProjectFileForm() {
    const sourceTargetColumnMapping = this.deleteUnselectedColumns();

    console.log('handleUpdateProjectFileForm.selectedJoinColumns',this.state.selectedJoinColumns);

    var data = {
        projectId:this.props.projectId,
        projectStructureId:this.state.projectStructureSelected,
        projectSupplierId: this.state.supplierSelected,
        projectFileName: this.state.projectFileName,
        file: this.state.file,
        fileName: this.state.fileName,
        structureSupplierMapping: {
          fileType:this.state.fileType,
          fileFormat: this.state.fileFormat,
          supplierNameRow : this.state.supplierNameRow,
          supplierStatmentPeriodRow : this.state.supplierStatmentPeriodRow,
          skipRows: this.state.skipRows,
          dataHeaderRow: this.state.dataHeaderRow,
          mergedCell: this.state.mergedCell,
          validationColumn: this.state.validationColumn,
          exceptionKeywords: this.state.exceptionKeywords,
         
          separator :this.state.separator,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          supplierCode: this.state.supplierCode,
       //   file: this.state.file,

          supplierName: this.state.supplierName,
          reportPeriodRange: this.state.reportPeriodRange,
          sourceTargetColumnMapping:sourceTargetColumnMapping,
          companyNameInColumns: this.state.companyNameInColumns,
          companyNameInRows: this.state.companyNameInRows,
          isStripType: this.state.isStripType,
          isCompanyAvailable: this.state.isCompanyAvailable,
          isConcatConversionAndUOM: this.state.isConcatConversionAndUOM,
          companyNameRowsCount: this.state.companyNameRowsCount,
          companyNameInColumnsIndex: this.state.companyNameInColumnsIndex,
          fileName: this.state.fileName,
          selectedJoinColumns: this.state.selectedJoinColumns,
          selectedCustomerColumns: this.state.selectedCustomerColumns,
          selectedProductColumns: this.state.selectedProductColumns,
          hasHeader: this.state.hasHeader,
          fileDateFormat: this.state.fileDateFormat,
          selectedAllColumnsArray: this.state.selectedAllColumnsArray,
          selectedAllColumns: this.state.selectedAllColumns,
          selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
        }
    }

    console.log('data', data);

    AppActions.setLoading(true);
	  projectFileService.update(this.props.projectFileId, data)
     .then((response) => {
        AppActions.setLoading(false);
        if(response.data.success){ // check for success
          this.newProjectFileCongigurationForm();
          var notify_message =({
            type:"success",
            message:"Project File Configuration has been updated successfully."
          });
          nav_actions.setSideNav(nav_store.dispatch, {});
          this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:response.data.err.name + " - May be duplicate Records"
            });
          }
          this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }
      });
	}

  handleCloneProjectFileForm() {
    const sourceTargetColumnMapping = this.deleteUnselectedColumns();
    var data = {
        projectId:this.props.projectId,
        projectStructureId:this.state.projectStructureSelected,
        projectSupplierId: this.state.supplierSelected,
        projectFileName: this.state.projectFileName,
        file: this.state.file,
        structureSupplierMapping: {
          fileType:this.state.fileType,
          fileFormat: this.state.fileFormat,
          supplierNameRow : this.state.supplierNameRow,
          supplierStatmentPeriodRow : this.state.supplierStatmentPeriodRow,
          skipRows: this.state.skipRows,
          dataHeaderRow: this.state.dataHeaderRow,
          mergedCell: this.state.mergedCell,
          validationColumn: this.state.validationColumn,
          exceptionKeywords: this.state.exceptionKeywords,
         
          separator :this.state.separator,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          supplierCode: this.state.supplierCode,
          
       //   file: this.state.file,
          supplierName: this.state.supplierName,
          reportPeriodRange: this.state.reportPeriodRange,
          sourceTargetColumnMapping:sourceTargetColumnMapping,
          companyNameInColumns: this.state.companyNameInColumns,
          companyNameInRows: this.state.companyNameInRows,
          isStripType: this.state.isStripType,
          isCompanyAvailable: this.state.isCompanyAvailable || true,
          isConcatConversionAndUOM: this.state.isConcatConversionAndUOM,
          companyNameRowsCount: this.state.companyNameRowsCount,
          companyNameInColumnsIndex: this.state.companyNameInColumnsIndex,
          selectedJoinColumns: this.state.selectedJoinColumns,
          selectedCustomerColumns: this.state.selectedCustomerColumns,
          selectedProductColumns: this.state.selectedProductColumns,
          fileDateFormat: this.state.fileDateFormat,
          selectedAllColumnsArray: this.state.selectedAllColumnsArray,
          selectedAllColumns: this.state.selectedAllColumns,
          selectedAllReplaceColumns: this.state.selectedAllReplaceColumns,
        }
    }
    AppActions.setLoading(true);
		projectFileService.create(data)
     .then((response) => {
        AppActions.setLoading(false);
        if(response.data.success){ // check for success
          this.newProjectFileCongigurationForm();
          var notify_message =({
            type:"success",
            message:"Project File Configuration has been created successfully."
          });
          nav_actions.setSideNav(nav_store.dispatch, {});
          this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
             if(response.data.err.code===11000)
             {
               var notify_message =({ 
                 type:"error",
                 message:"Duplicate Project Structure Name."
               });
             }
             else if(response.data.err.code==="ENOTEMPTY" || response.data.err.code==="ENOENT")
             {
               var notify_message =({ 
                 type:"error",
                 message:"Please Select file."
               });
             }
             else 
             {
               var notify_message =({ 
                 type:"error",
                 message:"Error in Cloning."
               });
             }
   
          }
          this.notify(notify_message.type,notify_message.message);
        //  this.props.redirectToViewProjectFile("/project/" + this.props.projectId + "/file",notify_message);
        }
        
      });
	}

  deleteUnselectedColumns() {
  
    const { sourceTargetColumnMapping, headers, fileType, hasHeader } = this.state;
    sourceTargetColumnMapping.map(item => {
      if(item.target || item.startIndex){
        let targetColumn = item.target;
        if(fileType === "textFile" && !hasHeader) {
          targetColumn = Number(item.target);
          if(SAUDI || EGYPT){
            targetColumn = (item.target);
          }
        }
        if(!headers.includes(targetColumn)){
          if(!SAUDI || EGYPT){
            delete item.target;
            delete item.source;
          }
        }
      } else {
        delete item.target;
        delete item.source;
      }
    });
    return sourceTargetColumnMapping;
  }

  handleFieldCount(e, name){
    const { sourceTargetColumnMapping, masterTableFields } = this.state;
    let sourceTargetColumnMappingArray = sourceTargetColumnMapping.length > 0 ? [...sourceTargetColumnMapping] : [...masterTableFields];

    sourceTargetColumnMappingArray.map(item => {
      if(item.fieldName === name) {
        item.checked = item.checked ? !item.checked : true;
      }
    });

    this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
    
  }
  
  handleHeaderChange(e) {
    const { target: { value, name } } = e;
    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    let sourceTargetColumnMappingArray = sourceTargetColumnMapping.length > 0 ? [...sourceTargetColumnMapping] : [...masterTableFields];

    sourceTargetColumnMappingArray.map(item => {
      if(item.fieldName === name) {
        item.source = name;
        item.target = value === "Select Target Field" ? '' : value;
      }
    });

    this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
  }

  colTransformFunctionChange(e, field_name){
    const { target: { value, name } } = e;
    const { sourceTargetColumnMapping, masterTableFields } = this.state;

    const fieldColArr = sourceTargetColumnMapping.length ? [...sourceTargetColumnMapping] : [...masterTableFields];
    const selectedFnDt = this.state.functionsList.find((item) => item.id === value);

    if (fieldColArr.length)
      this.setState({
        sourceTargetColumnMapping: fieldColArr
          .map((itm) => itm.fieldName === field_name ? (itm['transformFunction'] = selectedFnDt, itm) : itm)
      });
    }

  transFuncParamValChanged(e, field_name, field_id){
    const { target: { value, name } } = e;
    const { sourceTargetColumnMapping } = this.state;

    const fieldColArr = sourceTargetColumnMapping.map((stc) => {
      if(stc.fieldName === field_name) {
        if(stc.transformFunction) {
          if(stc.transformFunction.parameters && stc.transformFunction.parameters.length) {
            stc.transformFunction.parameters
            = stc.transformFunction.parameters
              .map((prm) => {
                if (prm._id === field_id) {
                //if(prm.parameterName === name) {
                  if (prm.source === "FieldName")
                    prm["sourceField"] = value;
                  if (prm.source === "MasterFieldName")
                    prm["sourceField"] = value;
                  else
                    prm["inputValue"] = value;
                }
                return prm;
              });
              return stc;
          }
          return stc;
        }
        return stc;
      }
      return stc;
    });

    this.setState({ sourceTargetColumnMapping: fieldColArr });
  }


  handleTransformTextChange(index, e, fieldName) {
    const { target: { value, name } } = e;
    const { sourceTargetColumnMapping } = this.state;
    
    const found = sourceTargetColumnMapping.some(el => {
      if(el.source === fieldName) {
        el['transformText'] = value;
        return true;
      }
    });
    if(!found){
      const obj = {};
      obj['source'] = fieldName;
      obj['transformText'] = value;
      let sourceTargetColumnMappingArray = [...sourceTargetColumnMapping, obj];
      this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
    }
  }


  handleComputedTypeChange(e) {
    const { target: { value, name } } = e;
    
    // const { columnsRowsMapping, setColumnsRowsMapping } = this.props;
    const { sourceTargetColumnMapping } = this.state;
    const fieldName = name.replace("_computedType", "");
    //const found = sourceTargetColumnMapping.some(el => el.source === fieldName);
    const found = sourceTargetColumnMapping.some(el => {
      if(el.source === fieldName) {
        el['computedType'] = value;
        return true;
      }
    });
    if(!found){
      const obj = {};
      obj['source'] = fieldName;
      obj['computedType'] = value;
      let sourceTargetColumnMappingArray = [...sourceTargetColumnMapping, obj];
      this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
    }
    
  }

  handleComputedTextChange(index, e, fieldName) {
    const { target: { value, name } } = e;
    const { sourceTargetColumnMapping } = this.state;
    
    const found = sourceTargetColumnMapping.some(el => {
      if(el.source === fieldName) {
        el['computedText'] = value;
        return true;
      }
    });
    if(!found){
      const obj = {};
      obj['source'] = fieldName;
      obj['computedText'] = value;
      let sourceTargetColumnMappingArray = [...sourceTargetColumnMapping, obj];
      this.setState({ sourceTargetColumnMapping: sourceTargetColumnMappingArray });
    }
  }


  removeDuplicate(arr, prop) {
    var new_arr = [];
    var lookup = {};
    for (var i in arr) {
        lookup[arr[i][prop]] = arr[i];
    }
    for (i in lookup) {
        new_arr.push(lookup[i]);
    }
    return new_arr;}

//this is for showing notification
notify(type, message) {
  toast(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    type: type,
  });
}


  render() {
    
    const {
        clearData,
         headers,
         viewTable,
         projectDetails,
         masterTableFields,
         masterTableFieldInitial,
         showSaveBtn,
         fileUploaded,
         fileName,
         file,
         projectStructureList,
         supplierList,
         showStructureFormFields,
         testRunBtn,
         showModalSupplier,
         showModalStructure,
         supplierNameTxt,
         supplierCodeTxt,
         supplierAddressTxt,
         supplierFilteredList,
         showSeparator,
         showStartDateIndex,
         showEndDateIndex,
         showSupplierCodeIndex,
         showSupplierName,
         showSupplierStatmentPeriodRow,
         showSkipRows,
         shoDataHeaderRow,
         functionsList,
         selectedJoinColumns,
         selectedCustomerColumns,
         selectedProductColumns,
         fileType,
         allColumnsArray,
         selectedAllColumnsArray,
         selectedAllReplaceColumns,
      // PostsListFour
    } = this.state;
    const {
      projectId,
      projectStructureId,
      projectFileId,
      cloneText
    // PostsListFour
  } = this.props;

 // const totalRowProcessed = this.state.rows.length > 0 ? this.state.rows.length - 1 : 0 || 0;
  const totalRowProcessed = this.state.rows.rowData && this.state.rows.rowData.length > 0 ? this.state.rows.rowData.length : 0 || 0;
  const totalRowCount = this.state.rows.totalRowCount || 0;
  const totalEmptyRowCount = this.state.rows.totalEmptyRowCount || 0;
  const totalErrorRowCount = this.state.rows.totalErrorRowCount || 0;

    return (
    <div>
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">
            {projectFileId ? "Edit Project File Configuration" : "Create New Project File Configuration" }
            <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/file"}><FcAcceptDatabase /> View All</Link>
          </h6>
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="">
            <Form>
              <Row form>
                <Col md="12" className="form-group">
                  <Row className="form-group-row">
                    <Col className="form-label" md="4"><label htmlFor="supplierSelected">Supplier</label></Col>
                    {projectFileId ? (
                      (!cloneText ? (
                      <Col className="form-field" md="8">{this.state.selectedProjectSupplierName}</Col>
                     ) :(
                      <> 
                      <Col className="form-field" md="6">
                        <FormInput
                          id="supplierSelected"
                          placeholder="Supplier Statement period Row"
                          value={this.state.supplierSelectedName}
                          onChange={this.onChangeSupplierSelected}
                          disabled={true}
                        />
                      </Col>
                      <Col md="2">
                          <Button
                            className="ml-3 mt-2"
                            variant="primary"
                            onClick={this.handleShowModalSupplier}
                          >
                            <FcSearch /> Search Supplier
                          </Button>
                        </Col>
                      </>
                     ) ) )
                     :(
                        <> 
                          <Col className="form-field" md="6">
                            <FormInput
                              id="supplierSelected"
                              placeholder="Supplier Statement period Row"
                              value={this.state.supplierSelectedName || ""}
                              onChange={this.onChangeSupplierSelected}
                              disabled={true}
                            />
                          </Col>
                          <Col md="2">
                              <Button
                                className="ml-3 mt-2"
                                variant="primary"
                                onClick={this.handleShowModalSupplier}
                              >
                                <FcSearch /> Search Supplier
                              </Button>
                            </Col>
                          </>
                      )
                    }
                  </Row>

                  <Row className="form-group-row">
                    <Col className="form-label" md="4"><label htmlFor="projectStructureSelected">Structure</label></Col>
                      {projectFileId ? (
                      <Col className="form-field" md="8">{this.state.selectedProjectStructureName}</Col>
                      ) :(
                        <Col className="form-field" md="8">
                          <FormSelect id="projectStructureSelected" onChange={this.onChangeProjectStructureSelected} value={this.state.projectStructureSelected} disabled={this.state.enableProjectStructure} >
                            <option value="">Select Structure</option>
                            {projectStructureList && projectStructureList.map((item,index) => {
                                  return (<option key={item.id} value={item.id}>{item.projectStructureName}</option>)
                                })
                              }
                          </FormSelect>
                        </Col>
                       )
                      }
                    </Row>

                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="projectFileName">File Configuration Name</label></Col>
                        {projectFileId ? (
                           (!cloneText ? (
                            <Col className="form-field" md="8">{this.state.selectedProjectFileName}</Col>
                           ) :(
                            <Col className="form-field" md="8">
                            <FormInput
                                id="projectFileName"
                                placeholder="File Configuration Name"
                                value={this.state.projectFileName}
                                onChange={this.onChangeProjectFileName}
                                disabled={true}
                              />
                            </Col>
                        ) ) ) :(
                        <Col className="form-field" md="8">
                          <FormInput
                              id="projectFileName"
                              placeholder="File Configuration Name"
                              value={this.state.projectFileName}
                              onChange={this.onChangeProjectFileName}
                              disabled={true}
                            />
                          </Col>
                            )
                          }
                    </Row>

                   {showStructureFormFields && (
                     <>
                        <Row className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="fileType">File Type</label></Col>
                          <Col className="form-field" md="8">{this.state.fileType === 'textFile' ? 'Text File' : this.state.fileType === 'excelFile' ? 'Excel File' : this.state.fileType === 'csvFile'? 'CSV File' : this.state.fileType}</Col>
                        </Row>
                        <Row className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="fileFormat">File Format</label></Col>
                          <Col className="form-field" md="8">{this.state.fileFormat}</Col>
                        </Row>
                       
                        {showSeparator && (
                          <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="separator">Separator</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="separator"
                                placeholder="Separator"
                                value={this.state.separator}
                                onChange={this.onChangeSeparator}
                              />
                            </Col>
                          </Row>
                          )
                        }

                        {showSupplierCodeIndex && (
                          <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="supplierCode">Supplier Code</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="supplierCode"
                                placeholder="Supplier Code"
                                value={this.state.supplierCode}
                                onChange={this.onChangeSupplierCode}
                              />
                            </Col>
                          </Row>
                          )
                        }

                        {showStartDateIndex && (
                          <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="StartDate">Start Date</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="startDate"
                                placeholder="Start Date"
                                value={this.state.startDate}
                                onChange={this.onChangeStartDate}
                              />
                            </Col>
                          </Row>
                          )
                        }

                        {showEndDateIndex && (
                          <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="endDate">End Date</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="endDate"
                                placeholder="End Date"
                                value={this.state.endDate}
                                onChange={this.onChangeEndDate}
                              />
                            </Col>
                          </Row>
                          )
                        }

                        {INDIA && showSupplierName && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Name Row</label></Col>
                            <Col className="form-field" md="8">
                              <FormInput
                                  id="supplierNameRow"
                                  placeholder="Supplier Name Row"
                                  value={this.state.supplierNameRow}
                                  onChange={this.onChangeSupplierNameRow}
                                />
                              </Col>
                          </Row>
                          )
                        }

                       {INDIA && showSupplierStatmentPeriodRow && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Supplier Statement period Row</label></Col>
                            <Col className="form-field" md="8">
                              <FormInput
                                  id="supplierStatmentPeriodRow"
                                  placeholder="Supplier Statement period Row"
                                  value={this.state.supplierStatmentPeriodRow}
                                  onChange={this.onChangeSupplierStatmentPeriodRow}
                                />
                              </Col>
                          </Row>
                          )
                        }

                        {INDIA && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="compnayNameInColumns">Company Name In Columns</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="compnayNameInColumns" onChange={this.onChangeCompanyNameInColumns} value={this.state.companyNameInColumns}>
                                <option value="true">True</option>
                                <option value="false">False</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        )}

                        {INDIA && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Company Name In Rows</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="compnayNameInRows" onChange={this.onChangeCompanyNameInRows} value={this.state.companyNameInRows}>
                                <option value="false">False</option>
                                <option value="true">True</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        )}

                        {this.state.companyNameInRows && (
                          <>
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="companyNameRowsCount">Count of Text in Row to be Excluded</label></Col>
                            <Col className="form-field" md="8">
                              <FormInput
                                  id="companyNameRowsCount"
                                  placeholder="Count of Text in Row to be Excluded"
                                  value={this.state.companyNameRowsCount}
                                  onChange={this.onChangeCompanyNameRowsCount}
                                />
                            </Col>
                          </Row>
                          <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="companyNameInColumnsIndex">Company Name In Column Index</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="companyNameInColumnsIndex"
                                placeholder="Column A"
                                value={this.state.companyNameInColumnsIndex}
                                onChange={this.onChangeCompanyNameInColumnsIndex}
                              />
                          </Col>
                        </Row>
                        </>
                        )}
                        

                      {showSkipRows && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="skipRows">Skip Rows</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="skipRows"
                                placeholder="Skip Rows"
                                value={this.state.skipRows}
                                onChange={this.onChangeSkipRows}
                              />
                            </Col>
                        </Row>
                        )
                      }
                      {shoDataHeaderRow && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="dataHeaderRow">Data Header Row</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="dataHeaderRow"
                                placeholder="Data Header Row"
                                value={this.state.dataHeaderRow}
                                onChange={this.onChangeDataHeaderRow}
                              />
                            </Col>
                        </Row>
                       )
                      }
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="mergedColumns">Merged Columns</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                                id="mergedColumns"
                                placeholder="Merged Columns"
                                value={this.state.mergedCell}
                                onChange={this.onChangeMergedColumns}
                              />
                            </Col>
                        </Row>
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="validationColumn">Validation Column</label></Col>
                          <Col className="form-field" md="8">
                            <FormInput
                              id="validationColumn"
                              placeholder="Validation Column"
                              value={this.state.validationColumn}
                              onChange={this.onChangeValidationColumn}
                            />
                          </Col>
                        </Row>
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Exception Keywords</label></Col>
                          <Col className="form-field" md="8">
                            <FormTextarea 
                                id="exceptionKeywords" 
                                placeholder="Exception Keywords" 
                                rows="3" 
                                value={this.state.exceptionKeywords}
                                onChange={this.onChangeExceptionKeywords}
                              />
                          </Col>
                        </Row>
                        {(SAUDI || EGYPT || INDIA) && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="fileDateFormat">Select File Date Format</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="fileDateFormat" onChange={this.onChangeFileDateFormat} value={this.state.fileDateFormat}>
                                <option value="">Select</option>
                                <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                                <option value="DD-MM-YYYY">DD-MM-YYYY</option>
                                <option value="DD.MM.YYYY">DD.MM.YYYY</option>
                                <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                                <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                                <option value="MM.DD.YYYY">MM.DD.YYYY</option>
                                <option value="DD-MMM-YY">DD-MMM-YY</option>
                                <option value="DD-MMM-YYYY">DD-MMM-YYYY</option>
                                <option value="DD MMMM YYYY">DD MMMM YYYY</option>
                                <option value="YYYY-DD-MM">YYYY-DD-MM</option>
                                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                                <option value="YYYYMMDD">YYYYMMDD</option>
                                <option value="YYYYMM">YYYYMM</option>
                                <option value="MMMM YYYY">MMMM YYYY</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        )}
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="feFirstName">Select File</label></Col>
                          <Col className="form-field" md="8">
                            <div className="custom-file mb-3">
                              <input 
                                  type="file" 
                                  className="custom-file-input" 
                                  id="file" 
                                  name="file"
                                  placeholder="Upload your excel file"
                                  onChange={this.readFile.bind(this)}
                              />
                              <label className="custom-file-label" htmlFor="customFile2">
                                Choose file...
                              </label>
                            </div>
                            {projectFileId && (
                              <div><FcApproval /> Uploaded Name : {fileName}</div>
                            )}
                            {fileUploaded && (
                              <div><FcApproval /> File Name : {file && file.name}</div>
                            )}
                          </Col>
                        </Row>

                        {INDIA && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="supplierName">Supplier Name</label></Col>
                          <Col className="form-field" md="8">
                            {this.state.supplierName}
                          </Col>
                        </Row>
                        )}

                        {INDIA && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="supplierName">Report Date Range </label></Col>
                            <Col className="form-field" md="8">
                              {this.state.reportPeriodRange && (this.state.reportPeriodRange.join(" To "))}
                            </Col>
                          </Row>
                        )}
                        {INDIA && (
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="isStripType">is Strip Type</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="isStripType" onChange={this.onChangeIsStripType} value={this.state.isStripType}>
                                <option value="false">False</option>
                                <option value="true">True</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        )}
                        {INDIA && this.state.fileFormat != "P FILE" && (
                          <>
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="isCompanyAvailable">is Company Available</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="isCompanyAvailable" onChange={this.onChangeIsCompanyAvailable} value={this.state.isCompanyAvailable}>
                                <option value="false">False</option>
                                <option value="true">True</option>
                              </FormSelect>
                            </Col>
                          </Row>

                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="isConcatConversionAndUOM">is Concat Conversion And UOM</label></Col>
                            <Col className="form-field" md="8">
                              <FormSelect id="isConcatConversionAndUOM" onChange={this.onChangeIsConcatConversionAndUOM} value={this.state.isConcatConversionAndUOM}>
                                <option value="false">False</option>
                                <option value="true">True</option>
                              </FormSelect>
                            </Col>
                          </Row>

                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="joinColumns">Remove & Replace String</label></Col>
                            <Col className="form-field" md="8">
                                {/* {masterTableFields && masterTableFields.length > 0 ? masterTableFields.map(
                                    (foitem, foindex) => {
                                      return <option key={foindex+1} value={foitem.apiKey}>{foitem.fieldName}</option>
                                    }) : 
                                  (<option key={prtm._id+1} value={prtm.sourceField}>{prtm.sourceField}</option>)
                                } */}
                              {allColumnsArray && (
                                <Select
                                  value={selectedAllColumnsArray}
                                  onChange={this.handleSelectedAllColumnsArrayChange}
                                  options={allColumnsArray}
                                  isMulti={true}
                                  defaultValue={selectedAllColumnsArray}
                                />
                                )}
                              <br />
                              <Row>
                                <Col>
                                  <FormInput
                                    id="selectedAllColumns"
                                    placeholder="Enter Remove String"
                                    value={this.state.selectedAllColumns}
                                    onChange={this.onChangeSelectedAllColumns}
                                  />
                                </Col>
                                <Col>
                                  <FormInput
                                    id="selectedAllReplaceColumns"
                                    placeholder="Enter Replace String"
                                    value={selectedAllReplaceColumns}
                                    onChange={this.onChangeSelectedAllReplaceColumns}
                                  />
                                </Col>
                              </Row>
                              
                            </Col>
                          </Row>

                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="joinColumns">Join Data on</label></Col>
                            <Col className="form-field" md="8">
                              {joinColumns && (
                                <Select
                                  value={selectedJoinColumns}
                                  onChange={this.handleChange}
                                  options={joinColumns}
                                  isMulti={true}
                                  defaultValue={selectedJoinColumns}
                                />
                                )}
                            </Col>
                          </Row>
                          </>
                        )}

                        {(SAUDI || EGYPT) && (
                          <>
                          <Row className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="joinColumns">Join Customer on</label></Col>
                            <Col className="form-field" md="8">
                              {joinCustomerColumns && (
                                <Select
                                  value={selectedCustomerColumns}
                                  onChange={this.handleCustomerChange}
                                  options={joinCustomerColumns}
                                  isMulti={true}
                                  defaultValue={selectedCustomerColumns}
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="joinColumns">Join Product on</label></Col>
                            <Col className="form-field" md="8">
                              {joinProductColumns && (
                                <Select
                                  value={selectedProductColumns}
                                  onChange={this.handleProductChange}
                                  options={joinProductColumns}
                                  isMulti={true}
                                  defaultValue={selectedProductColumns}
                                />
                              )}
                            </Col>
                          </Row>
                          </>
                        )}
                        
                        <Row  className="form-group-row">
                          <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">Source Target Column Mapping</label></Col>
                        </Row>
                        <Row className="form-group-row">
                          <Col className="form-label" md="1"  style={{"maxWidth": "5%"}}><label htmlFor="source">Count</label></Col>
                          <Col className="form-label" md="3"><label htmlFor="source">Source</label></Col>
                          <Col className="form-label" md="3"><label htmlFor="target">{fileType === "fixedLength" ? "Target" : "Start Index" }</label></Col>
                          {this.state.fileType == "fixedLength" ? (
                            <>
                              <Col className="form-label" md="3"><label htmlFor="columnLevelTransformation">Total Index</label></Col>
                              <Col className="form-label" md="2" style={{"maxWidth": "20%","flex":"0 0 20%"}}><label htmlFor="columnLevelTransformation">Column Level Transformation</label></Col>
                            </>
                          ): (
                            <>
                              <Col className="form-label" md="3"><label htmlFor="columnLevelTransformation">Column Level Transformation</label></Col>
                              <Col className="form-label" md="2" style={{"maxWidth": "20%","flex":"0 0 20%"}}><label htmlFor="computedColumn">Computed Column</label></Col> 
                            </>
                          )}
                          {/* <Col className="form-label" md="2" style={{"maxWidth": "20%","flex":"0 0 20%"}}><label htmlFor="computedColumn">Computed Column</label></Col> */}
                        </Row>

                        {masterTableFieldInitial && masterTableFieldInitial.map((mitem,mindex) => {
                          // if(mitem.apiKey && mitem.apiKey.replace('Additional_Column_', '') > 3) {
                          //   return;
                          // };
                          return (
                            <Row className="form-group-row" key={mindex+1}>
                              <Col className="form-label" md="1" style={{"maxWidth": "5%"}}>
                                <FormCheckbox key={mindex+1} className="mb-1" 
                                  name={"count_"+mitem.source} id={"count_"+mitem.source} 
                                  checked={mitem.checked}
                                  onChange={e => this.handleFieldCount(e, mitem.source)}
                                  / >
                              </Col>
                              <Col className="form-label" md="3"><label htmlFor="fieldName">{mitem.fieldName}</label></Col>
                              <Col className="form-field" md="3">


                              {fileUploaded ? ( // if previously uploaded
                                  <>
                                    {fileType === "fixedLength" ? (
                                      <FormInput
                                        id={mitem.fieldName + mitem.mindex +"_startIndexText"}
                                        name={mitem.fieldName}
                                        placeholder={"Enter Start Index"}
                                        value={mitem.startIndex || ""}
                                        onChange={(e) => this.onChangeStartIndex(e, mitem.fieldName)}
                                      />
                                    ): (
                                      <FormSelect name={mitem.source || mitem.fieldName} id={mitem.source || mitem.fieldName} onChange={this.handleHeaderChange.bind(this)}>
                                        <option>Select Target Field</option>
                                          {headers && headers.length && headers.map(function(items, index) {
                                                if((items.toString() === mitem.target))
                                                return <option key={mindex+index} value={mitem.target} selected>{mitem.target}</option>
                                                else
                                                return <option key={mindex+index} value={items}>{items}</option>
                                            })
                                          }
                                      </FormSelect>
                                    ) }
                                   </> 
                                  ):(
                                    <>
                                      {fileType === "fixedLength" ? (
                                        <FormInput
                                          id={mitem.fieldName + mitem.mindex +"_startIndexText"}
                                          name={mitem.fieldName}
                                          placeholder={"Enter Start Index"}
                                          value={mitem.startIndex}
                                          onChange={(e) => this.onChangeStartIndex(e, mitem.fieldName)}
                                        />
                                    ): (
                                      <FormSelect name={mitem.target} id={mitem.target} onChange={this.handleHeaderChange.bind(this)}>
                                        <option>Select Target Field</option>
                                        <option key={mindex+1+10} value={mitem.target} selected>{mitem.target}</option>
                                      </FormSelect>
                                    )}
                                    </>
                                    
                                  )
                                
                              }
                              </Col>

                              {fileType === "fixedLength" ? (
                                <Col className="form-field" md="3">
                                  <FormInput
                                      id={mitem.fieldName + mitem.mindex +"_totalIndexText"}
                                      name={mitem.fieldName}
                                      placeholder={"Enter Total Index"}
                                      value={mitem.totalIndex || ""}
                                      onChange={(e) => this.onChangeTotalIndex(e, mitem.fieldName)}
                                    />
                                </Col>
                              ): ( null )}

                            <Col className="form-field" md={fileType === 'fixedLength' ? '2': '3'}>

                                {/* {fileType === "fixedLength" ? (
                                    <FormInput
                                      id={mitem.fieldName + mitem.mindex +"_totalIndexText"}
                                      name={mitem.fieldName}
                                      placeholder={"Enter Total Index"}
                                      value={mitem.totalIndex || ""}
                                      onChange={(e) => this.onChangeTotalIndex(e, mitem.fieldName)}
                                    />
                                  ): ( */}
                                    <>
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <FormSelect name={mindex+"_"+mitem.id+"_transformType"} id={mindex+"_"+mitem._id+"_transformType"}
                                          onChange={(e) => this.colTransformFunctionChange(e, mitem.fieldName)}
                                          value={mitem.transformFunction ? mitem.transformFunction.id : ""}>
                                          <option>Select</option>
                                          {functionsList && functionsList.map(
                                              (item, index) => {
                                                return <option key={index+1} value={item.id}>{item.functionName}</option>
                                            })
                                          }
                                        </FormSelect>
                                        <button
                                          type="button"
                                          onClick={(e) =>
                                            this.addAdditionalField(
                                              e,
                                              mitem.fieldName
                                            )
                                          }
                                          className="btn btn-primary"
                                        >
                                          +
                                        </button>
                                      </div>
                                      {mitem.transformFunction && mitem.transformFunction.parameters && mitem.transformFunction.parameters.length 
                                          ? mitem.transformFunction.parameters.map((prtm, findex) => {
                                            return (
                                              <div key={prtm._id+"_transformWrap"}>
                                                {prtm.source === "FieldName" && (
                                                    <FormSelect className="mt-3" name={prtm.parameterName} id={prtm._id+"_transformType"}
                                                      onChange={(e) => this.transFuncParamValChanged(e, mitem.fieldName, prtm._id)}
                                                      value={prtm.sourceField || ""}>
                                                      <option>Select Parameter for {prtm.parameterName}</option>
                                                      {headers && headers.length > 0 ? headers.map(
                                                          (foitem, foindex) => {
                                                            return <option key={foindex+1} value={foitem}>{foitem}</option>
                                                          }) : 
                                                        (<option key={prtm._id+1} value={prtm.sourceField}>{prtm.sourceField}</option>)
                                                      }
                                                    </FormSelect>
                                                )}

                                                {prtm.source === "MasterFieldName" && (
                                                    <FormSelect className="mt-3" name={prtm.parameterName} id={prtm._id+"_transformType"}
                                                      onChange={(e) => this.transFuncParamValChanged(e, mitem.fieldName, prtm._id)}
                                                      value={prtm.sourceField || ""}>
                                                      <option>Select Parameter for {prtm.parameterName}</option>
                                                      {masterTableFields && masterTableFields.length > 0 ? masterTableFields.map(
                                                          (foitem, foindex) => {
                                                            return <option key={foindex+1} value={foitem.apiKey}>{foitem.fieldName}</option>
                                                          }) : 
                                                        (<option key={prtm._id+1} value={prtm.sourceField}>{prtm.sourceField}</option>)
                                                      }
                                                    </FormSelect>
                                                )}

                                                  {prtm.source == "CustomValue" && (
                                                    <FormInput
                                                    id={prtm +"_transformText"}
                                                    name={prtm.parameterName}
                                                    placeholder={"Enter value for " + prtm.parameterName}
                                                    className="mt-3"
                                                    value={prtm.inputValue || ""}
                                                    onChange={(e) => this.transFuncParamValChanged(e, mitem.fieldName, prtm._id)}
                                                  />
                                                )}
                                              </div>
                                              )
                                            }) : null
                                          }

                                    </>
                                 
                              
                              </Col>
                            </Row> 
                            )
                          })
                        }
                        
                        <Row  className="form-group-row">
                          <Col className="form-button" md="4">
                            {testRunBtn && (
                              <>
                              <Button className="btn btn-primary float-left mr-3" onClick={() => {this.viewOriginalFile(this.state.file);}} theme="accent"><FcDataConfiguration /> Test Run</Button>
                              <Button className="btn btn-primary float-left mr-3" onClick={() => {this.viewOriginalFile(this.state.file, 'testrunwithsp');}} theme="accent"><FcDataConfiguration /> Test Run With SP Function</Button>
                              {SPAIN && (
                                <Button className="btn btn-primary float-left mr-3 mt-4" onClick={() => {this.addAdditionalItem();}} theme="accent"><FcDataConfiguration /> Add Additional Column</Button>
                              )}
                              {/* <Button className="btn btn-primary float-left mr-3" onClick={() => {this.proccessFile(this.state.file); this.showTable();}} theme="accent"><FcDataConfiguration /> Test Run</Button> */}
                              {/* {`Total Rows processed: ${totalRowProcessed}`} */}
                            </>
                            )}
                          </Col>
                          <Col className="form-button" md="4">
                            {testRunBtn && (
                              <>
                              {`Total Rows Count: ${totalRowCount}`}
                              <br />
                              {`Total Empty Rows Count: ${totalEmptyRowCount}`}
                              <br />
                              {`Total Rows processed: ${totalRowProcessed}`}
                              <br />
                              {`Total Error Rows: ${totalErrorRowCount}`}
                              </>
                            )}
                          </Col>
                          <Col className="form-button" md="4">
                            {projectFileId ? 
                                (cloneText ?
                                  <Button variant="primary" className="float-left mr-3" onClick={this.handleCloneProjectFileForm}><FcPlus /> Clone File Configuration</Button>
                                  :  (showSaveBtn && (
                                  <Button variant="primary" className="float-left mr-3" onClick={this.handleUpdateProjectFileForm}><FcPlus /> Update File Configuration</Button>
                                  ))
                                )
                                : 
                                (showSaveBtn && (
                                <Button variant="primary" className="float-left mr-3" onClick={this.handleAddProjectFileConfigurationForm}><FcPlus /> Save File Configuration</Button>
                                )
                              )
                            }
                          </Col>
                        </Row>  
                     </>
                     )}
                </Col>
              </Row>
            </Form>
            {viewTable && (
              <>
            <Container>
                    <Row>
                        <TableColumnRow
                            rows={this.state.columnsRows}
                            headers={this.state.headers}
                            clearData={clearData}
                        />
                    </Row>
                </Container>
              
              <Container>
                  <Row>
                      <TableRow
                          rows={this.state.rows}
                          clearData={clearData}
                      />
                  </Row>
              </Container>
              </>
              )
           }
          </ListGroupItem>
        </ListGroup>
      </Card>

      <Modal show={showModalSupplier} size="lg" onHide={this.handleCloseModalSupplier}>
          <Modal.Header>
            <Modal.Title>Search Supplier</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.handleCloseModalSupplier}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="form-group-row">
                {/* <Col className="form-label" md="4">
                  <label htmlFor="supplierName">Supplier Name</label>
                </Col> */}
                <Col className="form-field" md="3">
                  <FormInput
                    id="supplierNameTxt"
                    placeholder="supplier Name"
                    value={supplierNameTxt}
                    onChange={this.onChangeSupplierNameTxt}
                  />
                </Col>
                <Col className="form-label text-center" md="1">
                or
                </Col>
                <Col className="form-field" md="3">
                  <FormInput
                    id="supplierCodeTxt"
                    placeholder="supplier Code"
                    value={supplierCodeTxt}
                    onChange={this.onChangeSupplierCodeTxt}
                  />
                </Col>
                <Col className="form-label text-center" md="1">
                or
                </Col>
                <Col className="form-field" md="4">
                  <FormInput
                    id="supplierAddressTxt"
                    placeholder="supplier Address"
                    value={supplierAddressTxt}
                    onChange={this.onChangeSupplierAddressTxt}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="2">
                  <label htmlFor="feFirstName">Supplier Name</label>
                </Col>
                <Col className="form-label" md="2">
                  <label htmlFor="feFirstName">Supplier Code</label>
                </Col>
                <Col className="form-label" md="6">
                  <label htmlFor="feFirstName">Supplier Address</label>
                </Col>
                <Col className="form-label" md="2">
                  <label htmlFor="feFirstName">Select</label>
                </Col>
              </Row>
                
              {supplierFilteredList && supplierFilteredList.map((item,index) => {
                return (
                    
                      <Row className="form-group-row" key={item.supplierCode}>
                        <Col className="form-field" md="2">
                          <label htmlFor="feSupplierName">{item.supplierName}</label>
                        </Col>
                        <Col className="form-field" md="2">
                          <label htmlFor="feSupplierCode">{item.supplierCode}</label>
                        </Col>
                        <Col className="form-field" md="6">
                          <label htmlFor="feSupplierAddress">{item.supplierAddress}</label>
                        </Col>
                        <Col className="form-field" md="2">
                        <Button
                            className="ml-3 mt-2"
                            variant="primary"
                            onClick={() => this.selectSupplier(item.id)}
                          >
                            <FcPlus /> Select
                          </Button>
                        </Col>
                      </Row>
                  
           
                )
              })
            }
            
            </Form>
          </Modal.Body>
        </Modal>

      
    </div>
    )
  }
}

export default CreateProjectStructure;
